import violationQuery from '../../views/violation-manage/violation-query.vue';
import historyViolationQuery from '../../views/violation-manage/violation-history-query.vue';
import violationAnalyze from '../../views/violation-manage/violation-analyze.vue';
import violationPurchase from '../../components/violation-manage/violation-purchase.vue';
import violationPurchaseRecord from '../../components/violation-manage/violation-purchase-record.vue';
var violationManage = [
    {
        name: 'violationQuery',
        path: 'violation-query',
        component: violationQuery,
    },
    {
        name: 'historyViolationQuery',
        path: 'history-violation-query',
        component: historyViolationQuery,
    },
    {
        name: 'violationAnalyze',
        path: 'violation-analyze',
        component: violationAnalyze,
    },
    {
        name: 'violationPurchase',
        path: 'violation-purchase',
        component: violationPurchase,
    },
    {
        name: 'violationPurchaseRecord',
        path: 'violation-purchase-record',
        component: violationPurchaseRecord,
    },
];
export default violationManage;
